import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'contract-create-navigation',
    templateUrl: './contract-create-navigation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContractCreateNavigationComponent {
  constructor() {}
}
